import { takeLatest } from 'redux-saga/effects';

import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';

import { flowGetAll } from '../api/chatFlows';
import {
  chatFlowsGetAll,
  chatFlowsGetAllFailed,
  chatFlowsGetAllSucceeded,
} from '../reducers/chatFlows';

// Saga
export const chatFlows = [
  takeLatest(
    chatFlowsGetAll.toString(),
    sagaApiGenWithPromise(
      flowGetAll,
      chatFlowsGetAllSucceeded,
      chatFlowsGetAllFailed,
    ),
  ),
];
